<template>
  <div>
    <div>
      <img :src="require('@/assets/images/catering.png')">
    </div>
    <van-list @load="getCatering" :finished="finished" :loading="loading">
      <cateringList
      v-for="item of cateringList"
      :key="item.id"
      :info="item"
      >
    </cateringList>
    </van-list>
  </div>
</template>
<script>
import { getCateringList } from '@/api/home'
import cateringList from './components/CateringList'
import { List } from 'vant'
export default {
  name: "Catering",
  components: {
    cateringList,
    [List.name]: List,
  },
  data () {
    return {
      cateringList: [],
      finished: true,
      loading: false,
      page: 0
    }
  },
  methods: {
    async getCatering () {
      this.page++;
      this.loading = true;
      const result = await getCateringList().catch(() => {
        this.loading = false;
        this.finished = true;
      })
      this.loading = false;
      const { data, status } = result.data.data;
      
      if (status && data.length > 0) {
        this.cateringList = data;
      }else {
        this.finished = true;
      }
    }
  },
  created () {
    this.getCatering()
  }
}
</script>